export function LogoMark({ className = "h-10 w-10" }) {
  return <img src="/brand/braintap-mascot.png" alt="BrainTap mascot" className={`object-contain ${className}`} />;
}

export function LogoLockup({ className = "h-10 w-auto" }) {
  return <img src="/brand/braintap-lockup.png" alt="braintap.bar" className={`object-contain ${className}`} />;
}

export function BrainTapLockup({ className = "w-full" }) {
  return <img src="/brand/braintap-logo-full.png" alt="braintap.bar — Come for the trivia, leave with a buzz!" className={className} />;
}

export function BrainTapLogo({ lockupClass = "h-14", mascotClass = null, className = "" }) {
  return <img src="/brand/braintap-logo-full.png" alt="braintap.bar" className={`object-contain ${lockupClass} ${className}`} />;
}
